// extracted by mini-css-extract-plugin
module.exports = {"header":"e_U2","gallery":"e_V2","label":"e_W2"};